import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import { RpcAction, RpcExclusionItemsMethod, RpcExclusionListsMethod, NewExclusionListWebComponentSchema, RpcUtilsMethod, RpcExclusionItemToListMappingsMethod } from '../types';
import { ConsoleRequest, DataProviderType } from '../../../utils/request';

export class NewExclusionListBaseDataProvider extends BaseWebComponentDataProvider {
  async getDataForView(listId): Promise<NewExclusionListWebComponentSchema> {
    throw new Error('Not implemented');
  }

  public async createExclusionItem(records): Promise<any> {
    return ConsoleRequest.createRequest<any>({
      dataProviderType: DataProviderType.ENDPOINTS,
      payload: {
        records: records,
      },
      endpoint: RpcAction.EXCLUSION_ITEMS,
      method: RpcExclusionItemsMethod.CREATE_RECORDS,
    });
  }

  public async createExclusionList(records): Promise<any> {
    return ConsoleRequest.createRequest<any>({
      dataProviderType: DataProviderType.ENDPOINTS,
      payload: {
        records: records,
      },
      endpoint: RpcAction.EXCLUSION_LISTS,
      method: RpcExclusionListsMethod.CREATE_RECORDS,
    });
  }

  public async updateExclusionList(records): Promise<any> {
    return ConsoleRequest.createRequest<any>({
      dataProviderType: DataProviderType.ENDPOINTS,
      payload: {
        records: records,
      },
      endpoint: RpcAction.EXCLUSION_LISTS,
      method: RpcExclusionListsMethod.UPDATE_RECORDS,
    });
  }

  public async assignMultipleItemsToList(companyId, itemsIds, listId): Promise<any> {
    return ConsoleRequest.createRequest<any>({
      dataProviderType: DataProviderType.ENDPOINTS,
      payload: {
        companyId: companyId,
        itemsIds: itemsIds,
        listId: listId,
      },
      endpoint: RpcAction.EXCLUSION_ITEM_TO_LIST,
      method: RpcExclusionItemToListMappingsMethod.ASSIGN_MULTIPLE_ITEMS_TO_LIST,
    });
  }

  public async importCsv(fields, file): Promise<any> {
    return ConsoleRequest.createRequestUpload<any>({
      dataProviderType: DataProviderType.CORE,
      payload: {
        csvFields: fields,
        csvFile: file,
      },
      endpoint: RpcAction.UTILS,
      method: RpcUtilsMethod.CONVERT_CSV_TO_JSON,
    });
  }

  public async getListInfo(companyId, listId): Promise<any> {
    return ConsoleRequest.createRequest<any>({
      dataProviderType: DataProviderType.ENDPOINTS,
      payload: {
        companyId: companyId,
        listId: listId,
      },
      endpoint: RpcAction.EXCLUSION_LISTS,
      method: RpcExclusionListsMethod.GET_LIST_INFO,
    });
  }
}
